import { render, staticRenderFns } from "./vFormAndProjectMixin.js.vue?vue&type=template&id=1c5c6a1a&"
import script from "./vFormAndProjectMixin.js.vue?vue&type=script&lang=js&"
export * from "./vFormAndProjectMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports